import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { DownloadableCouponRow } from '@models/coupon';
import dayjs from 'dayjs';
import { Dispatch, SetStateAction } from 'react';

import DownloadIcon from './DownloadIcon';
import useDownloadCoupon from './hooks/useDownloadCoupon';
import styles from './styles.module.scss';

interface Props {
    coupon:DownloadableCouponRow;
    setPage: Dispatch<SetStateAction<number>>
}

function DownloadAbleCoupon({ coupon, setPage }:Props) {
  const {
    couponImage, couponTitle, eventEndAt, availableShops,
  } = coupon;
  const downloadCoupon = useDownloadCoupon(coupon, setPage);
  const leftDays = dayjs(eventEndAt).diff(dayjs(), 'days');
  return (
      <Row fullWidth spacing={16} align='center'
           className={styles.container} >
          <div className={styles.itemImage}>
              <Image src={couponImage}
                     alt={couponTitle}
                     width={80}
                     height={80} />
          </div>
          <Column spacing={4}>
              <Text size='s' color={colors.gray8}>{availableShops}</Text>
              <Text size='lg' fontWeight='medium'>{couponTitle}</Text>
              <Text color={colors.gray7} size='s'>
                  유효기간 {dayjs(eventEndAt).format('YYYY.MM.DD')}
              </Text>
          </Column>
          <button className={styles.download}
                  onClick={downloadCoupon} >
              <DownloadIcon color={colors.gray4}/>
          </button>
      </Row>
  );
}

export default DownloadAbleCoupon;
